var SupportAPIHelper, SupportBaseTicketModel, SupportCallBackPhoneNumberModel, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBaseTicketModel = require('./base_ticket_model');

SupportUtilsHelper = require('../helpers/utils');

SupportAPIHelper = require('../helpers/API');

SupportCallBackPhoneNumberModel = (function(superClass) {
  extend(SupportCallBackPhoneNumberModel, superClass);

  function SupportCallBackPhoneNumberModel() {
    return SupportCallBackPhoneNumberModel.__super__.constructor.apply(this, arguments);
  }

  SupportCallBackPhoneNumberModel.prototype.initialize = function() {
    var ref;
    SupportBaseTicketModel.prototype.initialize.apply(this, arguments);
    this.getDefaultPhoneForm();
    this.userName = SupportUtilsHelper.getCurrentUserFullName() || null;
    this.userEmail = ((ref = window.currentUser) != null ? ref.email : void 0) || null;
    return this.phoneNumber = null;
  };

  SupportCallBackPhoneNumberModel.prototype.toJSON = function() {
    return {
      isLoggedIn: window.currentUser != null
    };
  };

  SupportCallBackPhoneNumberModel.prototype.getDefaultPhoneForm = function() {
    this.phoneForm = {
      method_of_contact: "callMeBackOption",
      objects: [
        {
          type: "user_name",
          label: I18n.translate('js.modules.support.user_label_full_name'),
          required: this.getRequired(),
          additional_attributes: {
            maximum_number_of_characters_or_digits: ""
          },
          value: this.userName
        }, {
          type: "email_address",
          label: I18n.translate('js.modules.support.call_me_back_email_label'),
          required: this.getRequired(),
          value: this.userEmail
        }, {
          type: "phone_number",
          label: I18n.translate('js.modules.support.call_me_back_your_number'),
          required: true
        }, {
          type: "language_dropDown",
          label: I18n.translate('js.modules.support.call_me_back_language'),
          required: true
        }, {
          type: "text_description",
          label: I18n.translate('js.modules.support.comments'),
          required: false
        }
      ]
    };
    if (Groupon.Support.FeatureFlagModel.isRecaptchaEnabled()) {
      this.phoneForm.objects.push({
        type: "recaptcha",
        required: true
      });
    }
    return this.phoneForm;
  };

  SupportCallBackPhoneNumberModel.prototype.getRequired = function() {
    if (!!this.userEmail && !!this.userName) {
      return false;
    } else {
      return true;
    }
  };

  SupportCallBackPhoneNumberModel.prototype.postToHoldTime = function(data, renderHoldTimePostSuccess, renderHoldTimePostError) {
    var successHandler, url;
    url = this.getCreateCallBackUrl();
    successHandler = function(response) {
      return renderHoldTimePostSuccess(response, data.locale, data.user_given_phone);
    };
    return SupportAPIHelper.call(url, 'POST', data, successHandler, renderHoldTimePostError, false);
  };

  SupportCallBackPhoneNumberModel.prototype.getCreateCallBackUrl = function() {
    var deal_type, ref, url;
    deal_type = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    url = window.SUPPORTBASEURL + "/hold_time/create?deal_type=" + deal_type + "&country_code=" + window.I18n.country;
    return SupportUtilsHelper.addMetaDataQueryParams(url);
  };

  return SupportCallBackPhoneNumberModel;

})(SupportBaseTicketModel);

module.exports = SupportCallBackPhoneNumberModel;

//# sourceMappingURL=data:application/json;base64,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
